import { useQuery } from '@tanstack/react-query';

import { makeQueryKeys } from '@/lib/query-keys';

import { availabilityService } from '../services/availabilityService';
import type { ListAvailabilityQuery } from '../types';

export const availabilityKeys = makeQueryKeys('availability');

/**
 * The BE rejects `?from=&to=` with a 400 (calendarDateString validator
 * requires YYYY-MM-DD), so callers that drive `from`/`to` from form state
 * would otherwise spam validation errors before the user picks a date.
 * Pause the query until practitionerId + both endpoints are non-empty.
 */
export function useAvailabilityRange(practitionerId: string, query: ListAvailabilityQuery) {
  const enabled = Boolean(practitionerId) && Boolean(query.from) && Boolean(query.to);
  return useQuery({
    queryKey: availabilityKeys.list({ practitionerId, ...query }),
    queryFn: () => availabilityService.listRange(practitionerId, query),
    enabled,
    staleTime: 30_000,
  });
}
